/*******************************************************************************
* Licensed Materials - Property of HCL 
* (c) Copyright HCL Technologies Ltd. 2020. All Rights Reserved. 

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/
/**
 * Component that creates a 3D panel stepper
 */

import React from "react";
import PropTypes from "prop-types";
import Text from "../Text";
import BackgroundPanel from "../BackgroundPanel";
import Button from "../Button";
import OverlayPanel from "../OverlayPanel";

function Banner({ data, setPosition, aframeClasses }) {
    const offset =
        data.width > data.height ? data.height * 0.05 : data.width * 0.05;
    const drawButtons = () => {
        let xPosition = data.width / 2;
        return [...data.buttons].reverse().map((elem, id) => {
            const button = (
                <Button
                    key={id}
                    disabled={elem.disabled}
                    text={elem.text}
                    width={elem.width}
                    height={data.height * 0.1}
                    type={elem.type}
                    onClickHandler={
                        elem.onClickHandler === "next"
                            ? () => setPosition((old) => old + 1)
                            : elem.onClickHandler === "back"
                            ? () => setPosition((old) => old - 1)
                            : elem.onClickHandler
                    }
                    aframeClasses={aframeClasses}
                    textSizeDecimal={data.textSizeDecimal || 50 / data.width}
                    position={`${xPosition - offset - elem.width / 2} ${
                        -data.height * 0.5 + offset + data.height * 0.05
                    } 0.0001`}
                />
            );
            xPosition -= elem.width + offset;
            return button;
        });
    };
    const drawOverlays = () => {
        if (!Array.isArray(data.overlay)) data.overlay = [data.overlay];
        return data.overlay.map((elem, id) => {
            return (
                <OverlayPanel
                    aframeClasses={aframeClasses}
                    key={id}
                    width={elem.width}
                    height={elem.height}
                    position={elem.position}
                />
            );
        });
    };
    return (
        <a-entity class="Banner">
            <BackgroundPanel
                width={data.width}
                height={data.height}
                position={data.position}
            >
                <Text
                    text={data.title}
                    width={data.width - offset * 2}
                    baseline="top"
                    position={`${-data.width * 0.5 + offset} ${
                        data.height * 0.5 - offset
                    } 0`}
                    sizeDecimal={40 / data.width}
                />
                <a-image
                    src={data.imageSrc}
                    width={data.width * 0.2}
                    height={data.width * 0.2}
                    position={`${-data.width * 0.4 + offset} 0.05 0`}
                />
                <Text
                    text={data.text}
                    width={data.width * 0.8 - offset * 2}
                    position={`${-data.width * 0.28 + offset} 0 0`}
                    sizeDecimal={data.textSizeDecimal || 50 / data.width}
                />
                {drawButtons()}
            </BackgroundPanel>
            {drawOverlays()}
        </a-entity>
    );
}

Banner.propTypes = {
    data: PropTypes.object.isRequired,
    setPosition: PropTypes.func.isRequired
};

export default Banner;
